import { Signal } from "@/data/util/Signal";

import { translations } from "@/shared/localization/translations";

import { BaseController } from "@/app/controller/BaseController";
import { Popup } from "@/app/ui/Popup";

export class BillController_new extends BaseController {
    public onContinue?: { () };
    public onShowServices?: { () };

    static onInit = new Signal();
    static onShown = new Signal();
    static onHidden = new Signal();

    static onContinue = new Signal();
    static onShowServices = new Signal();

    constructor() {
        super("bill");

        BillController_new.onContinue.add(this.continue, this);
        BillController_new.onShowServices.add(this.showServices, this);

        BillController_new.onInit.dispatch();
    }

    public showSelectionChangedPopup() {
        Popup.show(
            translations.pay.failedBillInvalidSelection,
            undefined,
            translations.general.ok,
            undefined,
            "pmtconfirm"
        );
    }

    protected onBecomeVisible() {
        BillController_new.onShown.dispatch();
    }

    protected onBecomeInvisible() {
        BillController_new.onHidden.dispatch();
    }

    protected showServices() {
        if (this.onShowServices) {
            this.onShowServices();
        }
    }

    protected continue() {
        if (this.onContinue) {
            this.onContinue();
        }
    }
}
